import { render, staticRenderFns } from "./table-status.vue?vue&type=template&id=1df1a7b8&scoped=true"
import script from "./table-status.vue?vue&type=script&lang=ts"
export * from "./table-status.vue?vue&type=script&lang=ts"
import style0 from "./table-status.vue?vue&type=style&index=0&id=1df1a7b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df1a7b8",
  null
  
)

export default component.exports